import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface InactiveInstrumentsToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const InactiveInstrumentsToggle: React.FC<InactiveInstrumentsToggleProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <FormControlLabel
      data-testid="inactive-instruments-toggle"
      control={
        <Checkbox
          data-testid="inactive-instruments-toggle-input"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label="Inactive"
      sx={{
        ml: '4px',
        opacity: disabled ? 0.6 : 1,
      }}
    />
  );
};

export default InactiveInstrumentsToggle;
